var map = {
	"./about-us/style.scss": "./template/blocks/about-us/style.scss",
	"./brand-zone/style.scss": "./template/blocks/brand-zone/style.scss",
	"./common-slider/style.scss": "./template/blocks/common-slider/style.scss",
	"./hero-slider/style.scss": "./template/blocks/hero-slider/style.scss",
	"./latest-posts/style.scss": "./template/blocks/latest-posts/style.scss",
	"./our-shoowrooms/style.scss": "./template/blocks/our-shoowrooms/style.scss",
	"./product-category-slider/style.scss": "./template/blocks/product-category-slider/style.scss",
	"./product-slider-with-tabs/style.scss": "./template/blocks/product-slider-with-tabs/style.scss",
	"./products-slider-by-category/style.scss": "./template/blocks/products-slider-by-category/style.scss",
	"./sell-product/style.scss": "./template/blocks/sell-product/style.scss",
	"./wrapper-block/style.scss": "./template/blocks/wrapper-block/style.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./template/blocks sync recursive style\\.scss$";